import { Link } from 'react-router-dom'

const MORE_ITEMS = [
  { label: 'Recipes',       to: '/recipes',        icon: '🍳' },
  { label: 'Health',        to: '/health',         icon: '🏃' },
  { label: 'Pantry',        to: '/pantry',         icon: '🥫' },
  { label: 'Vault',         to: '/vault',          icon: '🔒' },
  { label: 'Rewards',       to: '/rewards',        icon: '⭐' },
  { label: 'Notes',         to: '/notes',          icon: '📝' },
  { label: 'Docs',          to: '/documents',      icon: '📄' },
  { label: 'Contacts',      to: '/contacts',       icon: '📞' },
  { label: 'Vehicles',      to: '/vehicles',       icon: '🚗' },
  { label: 'Medications',   to: '/medications',    icon: '💊' },
  { label: 'Custody',       to: '/custody',        icon: '🏠' },
  { label: 'Birthdays',     to: '/birthdays',      icon: '🎂' },
  { label: 'Wall',          to: '/wall',           icon: '📋' },
  { label: 'Gallery',       to: '/gallery',        icon: '📷' },
  { label: 'Chat',          to: '/messages',       icon: '💬' },
  { label: 'Members',       to: '/members',        icon: '👥' },
  { label: 'Board',         to: '/announcements',  icon: '📢' },
  { label: 'Billing',       to: '/billing',        icon: '💳' },
  { label: 'Wall Display', to: '/settings/display', icon: '📺' },
  { label: 'Settings',      to: '/settings',       icon: '⚙️' },
]

export const MoreDrawer = ({ open, onClose }) => {
  if (!open) return null

  return (
    <>
      <div
        className="fixed inset-0 bg-black/40 z-40"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="fixed inset-x-0 bottom-0 bg-surface rounded-t-lg z-50 safe-bottom">
        <div className="p-4 pb-6">
          <div className="w-10 h-1 bg-border rounded-full mx-auto mb-6" />
          <h2 className="text-sm font-semibold text-text-secondary mb-4 px-1">More features</h2>
          <div className="grid grid-cols-4 gap-3">
            {MORE_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={onClose}
                className="flex flex-col items-center gap-1.5 p-3 rounded-base bg-background text-text-secondary text-xs font-medium hover:bg-primary-light hover:text-primary transition-colors"
              >
                <span className="text-xl">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
